import React, { useState } from "react";
import {
  markProductVariantInStock,
  markProductVariantOutOfStock,
} from "../../../services/productVariantService";
import Swal from "sweetalert2";
import { handleErrors } from "../../../utils/errorHandler";

const ProductVariantStockToggleSwitch = ({
  propId,
  initialStatus,
  onStatusChange,
}) => {
  const [isFeatured, setisFeatured] = useState(initialStatus === "In-Stock");

  const handleToggle = async () => {
    const newStatus = isFeatured ? "Out-off-Stock" : "In-Stock";
    const modalTitle = isFeatured
      ? "Mark Product Variant Out of Stock"
      : "Mark Product Variant In Stock";
    const modalMessage = isFeatured
      ? "Are you sure you want to mark this product variant out of stock?"
      : "Are you sure you want to mark this product variant in stock?";

    const result = await Swal.fire({
      title: modalTitle,
      text: modalMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        if (isFeatured) {
          await markProductVariantOutOfStock(propId, newStatus);
        } else {
          await markProductVariantInStock(propId, newStatus);
        }
        setisFeatured(!isFeatured);
        onStatusChange(newStatus);

        Swal.fire(
          "Success!",
          `The product variant has been ${
            newStatus === "In-Stock" ? "In-Stock" : "Out-off-Stock"
          }.`,
          "success"
        );
      } catch (error) {
        handleErrors(error);
      }
    }
  };

  return (
    <label className="switch">
      <div className="form-check form-switch form-switch-custom form-switch-primary">
        <input
          className="form-check-input"
          type="checkbox"
          checked={isFeatured} // Checked means user is Blocked
          onChange={handleToggle}
        />
      </div>
      <span className="slider round"></span>
    </label>
  );
};

export default ProductVariantStockToggleSwitch;
